import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SupplierPortalMembership } from '../models/user-profile.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthDataService {
  private readonly http = inject(HttpClient);

  loadMemberships() {
    return this.http.get<SupplierPortalMembership[]>(
      `${environment.CRD_API}v1/supplier-portal/supplier/memberships`,
      { headers: new HttpHeaders({ 'no-default-interceptor': '1' }) }
    );
  }
}
